import { ErrorsEnum } from './errors.enum.js';

export class FactoryNotFound extends Error {
  code = ErrorsEnum.FactoryNotFound;
  constructor(public name: string) {
    super(`Factory ${name} not found`);
  }
}
